<template>
    <div class="left-block">
        <Logo/>
        <BLink v-if="!isMainDomain && !isGuest && Object.keys(currentUserAccount).length" href="/projects" class="btn link-block" :class="classesLinkBlock(['projects'])" v-ripple>
            <i class="mi-layers mr-1"></i><span>Projects</span>
        </BLink>
        <BDropdown
            v-if="!isMainDomain && (isCurrentAccountOwner || currentUserCan('manage_roles') || currentUserCan('manage_users'))"
            variant="default"
            :toggle-class="classesLinkBlock(['users/active', 'roles-and-permissions', 'account/teams'], ['p-0', 'dropdown-toggle-unset'])"
            :no-caret="true">
            <template #button-content>
                <div class="button-dropdown dropdown-toggle" v-ripple>
                    <i class="mi-people mr-1"></i><span>Team</span>
                </div>
            </template>

            <BLink href="/users/active"
                   v-if="currentUserCan('manage_users')"
                   class="btn dropdown-item"
                   :style="stylesLinkBlock(['users/active'])"
                   :class="classesLinkBlock(['users/active'])"
                   v-ripple>
                <span>Users</span>
            </BLink>
            <BLink href="/roles-and-permissions"
                   v-if="currentUserCan('manage_roles') || isCurrentAccountOwner"
                   class="btn dropdown-item"
                   :style="stylesLinkBlock(['roles-and-permissions'])"
                   :class="classesLinkBlock(['roles-and-permissions'])"
                   v-ripple>
                <span>Roles</span>
            </BLink>
            <BLink href="/account/teams"
                   v-if="currentUserCan('manage_users')"
                   class="btn dropdown-item"
                   :class="classesLinkBlock(['account/teams'])"
                   :style="stylesLinkBlock(['account/teams'])"
                   v-ripple>
                <span>Teams</span>
            </BLink>

        </BDropdown>
        <BLink v-if="!isMainDomain && currentUserCan('view_editorial_calendar')" href="/reports/calendar" class="btn link-block" :class="classesLinkBlock(['reports/calendar'])" v-ripple>
            <i class="mi-date-range mr-1"></i><span>Calendar</span>
        </BLink>
        <BLink v-if="!isMainDomain && currentUserCan('manage_integrations')" href="/integration" class="btn link-block" :class="classesLinkBlock(['integration'])" v-ripple>
            <i class="mi-device-hub mr-1"></i><span>Integrations</span>
        </BLink>
        <BDropdown
            v-if="!isMainDomain && (currentUserCan('view_content_report') || currentUserCan('view_communication_report'))"
            variant="default"
            :toggle-class="classesLinkBlock(['reports/content', 'reports/communication'], ['p-0', 'dropdown-toggle-unset'])"
            :no-caret="true">
            <template #button-content>
                <div class="button-dropdown dropdown-toggle" v-ripple>
                    <i class="mi-poll mr-1"></i><span>Reports</span>
                </div>
            </template>

            <BLink href="/reports/content"
                   v-if="currentUserCan('view_content_report')"
                   class="btn dropdown-item"
                   :style="stylesLinkBlock(['reports/content'])"
                   :class="classesLinkBlock(['reports/content'])"
                   v-ripple>
                <span>Content report</span>
            </BLink>
            <BLink href="/reports/communication"
                   v-if="currentUserCan('view_communication_report')"
                   class="btn dropdown-item"
                   :style="stylesLinkBlock(['reports/communication'])"
                   :class="classesLinkBlock(['reports/communication'])"
                   v-ripple>
                <span>Communication</span>
            </BLink>

        </BDropdown>

        <BLink v-if="!isMainDomain && currentUserCan('access_content_migration')"
               href="/content-migration" class="btn link-block"
               :class="classesLinkBlock('content-migration')"
               v-ripple>
            <i class="mi-cloud-upload mr-1"></i><span>Content Migration</span>
            <span v-if="freeTrialNotExpired === true" class="badge badge-danger text-uppercase ml-1">new</span>
        </BLink>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import Logo from './components/Logo';
import {BDropdown, BLink} from 'bootstrap-vue';
import mixinNavbar from '@/mixins/navbar/mixin';

export default {
    name: 'LeftBlock',
    components: {
        BDropdown,
        Logo,
        BLink,
    },
    computed: {
        ...mapGetters(['currentUserCan', 'isCurrentAccountOwner']),
        ...mapState({
            projectId: state => state.navbar.projectId,
            isSuperAdmin: state => state.navbar.isSuperAdmin,
            accountName: state => state.navbar.accountName,
            isMainDomain: state => state.navbar.isMainDomain,
            isGuest: state => state.navbar.isGuest,
            currentUserAccount: state => state.navbar.currentUserAccount,
            freeTrialNotExpired: state => state.navbar.freeTrialNotExpired,
        }),
    },
    mixins: [mixinNavbar]
}
</script>
